var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 44,
    viewBox: "0 0 59 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "subtitle",
    d: "M0.9375 43.9086L0.9375 30.8895C0.9375 27.1928 1.66078 23.4156 3.10734 19.5581C4.5539 15.7006 6.46256 12.0641 8.83331 8.64866C11.2041 5.23316 13.7757 2.38023 16.5483 0.0898438L27.8797 6.78019C25.6295 10.3162 23.7811 14.013 22.3345 17.8705C20.9282 21.728 20.225 26.0275 20.225 30.769V43.9086H0.9375ZM31.3755 43.9086V30.8895C31.3755 27.1928 32.0988 23.4156 33.5454 19.5581C34.9919 15.7006 36.9006 12.0641 39.2714 8.64866C41.6421 5.23316 44.2138 2.38023 46.9863 0.0898439L58.3177 6.78019C56.0675 10.3162 54.2191 14.013 52.7726 17.8705C51.3662 21.728 50.663 26.0275 50.663 30.769V43.9086H31.3755Z",
    fill: "#2C4F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitle);
export default __webpack_public_path__ + "static/media/subtitle.038406ea758b2783d24490f8518cfb0b.svg";
export { ForwardRef as ReactComponent };